(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["static-slideshow"]) return;
  try {
    
  if (!customElements.get('bear-creek-hero')) {
    customElements.define('bear-creek-hero', class extends HTMLElement {
      connectedCallback() { queueMicrotask(() => this.initialize()); }
      initialize() {
        if (this.initialized) return;
        this.initialized = true;
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        if (!this.slides.length) return;
        this.abort = new AbortController();
        this.signal = this.abort.signal;
        this.index = 0;
        this.serial = 0;
        this.paused = this.dataset.autoplay !== 'true';
        this.inView = true;
        this.focused = false;
        this.delay = Math.max(5000, Number(this.dataset.interval) || 6000);
        this.pauseButton = this.querySelector('[data-pause]');
        this.querySelector('[data-controls]').hidden = this.slides.length < 2;
        this.querySelector('[data-next]').addEventListener('click', () => this.manual(this.index + 1), {signal:this.signal});
        this.querySelector('[data-previous]').addEventListener('click', () => this.manual(this.index - 1), {signal:this.signal});
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.manual(index), {signal:this.signal}));
        this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; if (!this.paused) this.focused = false; this.updateControls(); this.schedule(); }, {signal:this.signal});
        this.addEventListener('focusin', event => { this.focused = Boolean(event.target.closest('[data-slide]')) && event.target.matches(':focus-visible'); this.schedule(); }, {signal:this.signal});
        this.addEventListener('focusout', () => queueMicrotask(() => { this.focused = this.contains(document.activeElement) && Boolean(document.activeElement.closest('[data-slide]')) && document.activeElement.matches(':focus-visible'); this.schedule(); }), {signal:this.signal});
        this.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight'].includes(event.key) || /INPUT|TEXTAREA|SELECT/.test(event.target.tagName)) return;
          event.preventDefault();
          this.manual(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }, {signal:this.signal});
        this.addEventListener('pointerdown', event => { if (event.pointerType === 'touch') this.touch = {x:event.clientX,y:event.clientY}; }, {signal:this.signal,passive:true});
        this.addEventListener('pointerup', event => {
          if (event.pointerType !== 'touch' || !this.touch) return;
          const dx = event.clientX - this.touch.x;
          const dy = event.clientY - this.touch.y;
          this.touch = null;
          if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) this.manual(this.index + (dx < 0 ? 1 : -1));
        }, {signal:this.signal,passive:true});
        this.addEventListener('pointercancel', () => { this.touch = null; }, {signal:this.signal});
        document.addEventListener('visibilitychange', () => this.schedule(), {signal:this.signal});
        this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.schedule(); }, {threshold:0.05});
        this.observer.observe(this);
        document.addEventListener('shopify:block:select', event => { const selected = event.target.closest('[data-slide]'); const index = this.slides.indexOf(selected); if (index >= 0) { this.paused = true; this.manual(index); this.updateControls(); } }, {signal:this.signal});
        this.updateControls();
        this.preloadNext();
        this.schedule();
      }
      updateControls() {
        this.pauseButton.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.pauseButton.setAttribute('aria-pressed', String(this.paused));
        this.querySelector('[data-play-icon]').hidden = !this.paused;
        this.querySelector('[data-pause-icon]').hidden = this.paused;
      }
      preloadNext() {
        if (this.slides.length > 1) this.slides[(this.index + 1) % this.slides.length].querySelector('img').loading = 'eager';
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.isConnected || this.paused || this.focused || !this.inView || document.hidden || this.slides.length < 2) return;
        this.timer = setTimeout(() => this.show(this.index + 1, false), this.delay);
      }
      manual(index) {
        this.focused = false;
        this.show(index, true);
      }
      async show(index, announce) {
        clearTimeout(this.timer);
        const next = (index + this.slides.length) % this.slides.length;
        if (next === this.index) { this.schedule(); return; }
        const serial = ++this.serial;
        const img = this.slides[next].querySelector('img');
        img.loading = 'eager';
        try { await img.decode(); } catch {}
        if (serial !== this.serial || !this.isConnected) return;
        if (this.transition) this.transition.skipTransition();
        const apply = () => {
          this.slides.forEach((slide, i) => { slide.hidden = i !== next; slide.inert = i !== next; slide.setAttribute('aria-hidden', String(i !== next)); });
          this.dots.forEach((dot, i) => { if (i === next) dot.setAttribute('aria-current','true'); else dot.removeAttribute('aria-current'); });
          this.index = next;
          this.querySelector('[data-counter]').textContent = `${next + 1} / ${this.slides.length}`;
          if (announce) this.querySelector('[data-status]').textContent = `${next + 1} / ${this.slides.length}: ${this.slides[next].dataset.title}`;
          this.preloadNext();
        };
        apply();
        this.schedule();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.serial++;
        this.abort?.abort();
        this.observer?.disconnect();
        this.transition?.skipTransition();
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
